import * as React from 'react';
import { Dispatch } from 'react-redux';
import { DriveItemInfo } from '../../containers/DriveItemList/reducer';
import { StoreState } from '../../reducers';
import { PageOverlay } from '../PageOverlay/styles';
import { closeContextualMenu } from '../../containers/DriveItemList/actions';
import { DropdownContainer, DropDownList } from './styles';
import Item from '../../containers/ContextualMenu/Item';
import { ContextualMenuItemType } from './constants';

interface ContextualMenuProps {
	dispatch: Dispatch<StoreState>;
	isOpened: boolean;
	driveItem: DriveItemInfo | undefined;
	buttons: ContextualMenuButtons;
}

type ContextualMenuButtons = { [K in ContextualMenuItemType]: boolean; };

class ContextualMenu extends React.Component<ContextualMenuProps, never> {

	constructor(props: ContextualMenuProps) {
		super(props);
	}

	onOverlayClick() {
		const { dispatch } = this.props;

		dispatch(closeContextualMenu());
	}

	getItemsType(): ContextualMenuItemType[] {
		const { buttons } = this.props;
		let itemsType: ContextualMenuItemType[] = [];

		Object.keys(ContextualMenuItemType)
			.forEach(key => {
				const contextualMenuItemType = ContextualMenuItemType[key];
				if (buttons[key]) {
					itemsType.push(contextualMenuItemType);
				}
			})
		;

		return itemsType;
	}

	renderItems(): JSX.Element[] {
		const itemsData = this.getItemsType();

		return itemsData.map(itemType => (
			<Item type={itemType} key={itemType}/>
		));
	}

	render() {
		const { isOpened } = this.props;

		return (
			<>
				<PageOverlay isOpen={isOpened} onClick={() => this.onOverlayClick()}/>
				{isOpened &&
					<DropdownContainer>
						<DropDownList>
							{this.renderItems()}
						</DropDownList>
					</DropdownContainer>
				}
			</>
		);
	}
}

export default ContextualMenu;
export {
	ContextualMenuButtons,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/index.tsx